import { EditorState } from "@common/Common";
import type { ValidationError } from "@common/types";
import type { DiscreteScaleLevelReadModel } from "@Scales/readmodels";

export class DiscreteScaleEditorViewModel
{
    state: EditorState = EditorState.Closed;

    scaleId: number | null = null;
    name: string | null = null;
    description: string | null = null;

    levels: DiscreteScaleLevelReadModel[] = [];

    nameError: string | null = null;
    descriptionError: string | null = null;
    levelsError: string | null = null;

    get opened(): boolean { return this.state !== EditorState.Closed; }

    showCreator(name: string, description: string | null, levels: DiscreteScaleLevelReadModel[])
    {
        this.scaleId = null;
        this.name = name;
        this.description = description;
        this.levels = levels;

        this.state = EditorState.Creator;
    }

    showEditor(scaleId: number, name: string, description: string | null, levels: DiscreteScaleLevelReadModel[])
    {
        this.scaleId = scaleId;
        this.name = name;
        this.description = description;
        this.levels = JSON.parse(JSON.stringify(levels)) as DiscreteScaleLevelReadModel[];

        this.state = EditorState.Editor;
    }

    close()
    {
        this.state = EditorState.Closed;

        this.scaleId = null;
        this.name = null;
        this.description = null;
        this.levels = [];
    }


    clearValidationErrors()
    {
        this.nameError = null;
        this.descriptionError = null;

        this.levelsError = null;

        this.levels.forEach(l =>
        {
            l.NameError = null;
            l.ValueError = null;
        });
    }

    displayValidationErrors(errors: ValidationError[])
    {
        for (const error of errors)
        {
            if (error.Context === "Name")
            {
                this.nameError = error.Error;
            }
            else if (error.Context === "Description")
            {
                this.descriptionError = error.Error;
            }
            else if (error.Context === "ScaleLevels")
            {
                this.levelsError = error.Error;
            }
            else if (error.Context === "ScaleLevelName")
            {
                const lvl = this.levels.find(a => a.Name === error.Value);

                if (lvl)
                {
                    lvl.NameError = error.Error;
                }
            }
            else if (error.Context === "ScaleLevelValue")
            {
                const lvl = this.levels.find(a => a.Name === error.Value);

                if (lvl)
                {
                    lvl.ValueError = error.Error;
                }
            }
        }
    }

}